import client from 'services/networking/client';
import { type B2bUserType, UserContext } from 'shared-types/user';
import type { View } from 'shared-types/view-data';

export const addB2cView = async (songId: string, username?: string): Promise<View> => {
  return client.post('/view/b2c', { songId, username, userContext: UserContext.BKO }).catch((e) => {
    throw new Error(
      `View count call failed with following song: ${songId}. HTTP Call error message: ${e.message}`,
    );
  });
};

export const addB2bView = async (songId: string, userContext: B2bUserType): Promise<View> => {
  return client.post('/view/b2b', {
    songId,
    userContext: userContext.toUpperCase(),
  }); // Refact to use UserContext instead converting B2bUserType
};
